import { __decorate, __metadata, __param } from "tslib";
import { Directive, Inject } from 'angular-ts-decorators';
import { isElementHidden, isMobile } from 'src/Foundation/Design/app';
var ShowOnVideoAvailabilityDirective = (function () {
    function ShowOnVideoAvailabilityDirective($element) {
        this.$element = $element;
    }
    ShowOnVideoAvailabilityDirective.prototype.ngOnInit = function () {
        var video = document.querySelector('.support-video-spot');
        if (video === null || isElementHidden(video) || !isMobile()) {
            this.$element.addClass('ng-hide');
        }
    };
    ShowOnVideoAvailabilityDirective.$inject = ['$element'];
    ShowOnVideoAvailabilityDirective = __decorate([
        Directive({
            selector: '[showOnVideoAvailability]',
        }),
        __param(0, Inject('$element')),
        __metadata("design:paramtypes", [Object])
    ], ShowOnVideoAvailabilityDirective);
    return ShowOnVideoAvailabilityDirective;
}());
export { ShowOnVideoAvailabilityDirective };
